import { useSelector } from 'react-redux';
import { buildTrackingPageUrl, getFallbackProxyPath } from '@/helpers/trackingPageUrl';
import { useGetProxyPathQuery } from '@/redux/api/api.caller';
import { tokenSelector } from '@/redux/features/auth.slice';

export default function useTrackingPageUrl() {
  const { shop } = useSelector(tokenSelector);
  const { data } = useGetProxyPathQuery();
  const proxyPath = data?.data?.proxyPath || getFallbackProxyPath();

  return { shop, proxyPath, url: buildTrackingPageUrl(shop, proxyPath) };
}
